<!--
 * @Description: 登录页
 * @Author: luocheng
 * @Date: 2021-10-25 10:26:07
 * @LastEditors: luocheng
 * @LastEditTime: 2022-07-14 17:19:58
-->
<template>
  <div class="login">
   <article class="login-main">
     <section class="left-main">
      <div class="logo-box">
        <img src="https://jgzl1.bimcc.net/uploads/202004/26/1587888993_Q9BZE3M16f_thumb.png" alt="logo" class="logo">
      </div>
      <div class="title-box">
        <h3 class="title">重庆建工工程师智库</h3>
      </div>
      <article class="login-content">
        <!-- 验证码登录 -->
        <LoginForm></LoginForm>
      </article>
     </section>
     <section class="diamond">
       <img src="https://openim-1309784708.cos.ap-shanghai.myqcloud.com/openim/diamond-24C4825417CF73B932331D390E2A6C862.png" class="diamond-img" alt="介绍">
     </section>
   </article>
  </div>
</template>

<script>
import LoginForm from '../components/LoginForm';

export default {
  name: 'Login',
  components: {
    LoginForm
  }
}
</script>

<style lang="less" scoped>
.login{
  height: 100vh;
  width: 100vw;
  min-width: 860px;
  min-height: 800px;
  background: #fff;
  background-image: url('https://openim-1309784708.cos.ap-shanghai.myqcloud.com/openim/login_bg_179B9082D2CD77071C8D234305B7D1992.jpeg');
  background-repeat: no-repeat;
  background-clip: border-box;
  background-size: 100% 100%;
  // background-size: cover;
  overflow: hidden;
  position: relative;
  .login-main{
    box-sizing: border-box;
    padding: 10vh 7vw;
    min-width: 860px;
    min-height: 800px;
    overflow: hidden;
    border-radius: 20px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    background-image: url('https://openim-1309784708.cos.ap-shanghai.myqcloud.com/openim/content_bg_18A10B73D5FF730D3B75C34667DE49E59.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    .left-main{
      flex: 1;
      .logo-box{
        width: 80px;
        position: relative;
        .logo{
          width: 80px;
          display: block;
          object-fit: cover;
        }
      }
      .title-box{
        position: relative;
        width: 520px;
        height: 110px;
        box-sizing: border-box;
        padding-top: 40px;
        overflow: hidden;
        .title{
          color: rgb(12, 25, 117);
          text-align: center;
          font-size: 36px;
          font-weight: 1000;
          line-height: 48px;
          font-family:  PingFangSC, PingFangSC-Semibold;
        }
      }
      .login-content{
        height: 467px;
        width: 520px;
        background-image: url('https://openim-1309784708.cos.ap-shanghai.myqcloud.com/openim/form_bg804B05D0AFB9CAF6237685F9B8DF28AB.png');
        background-size: 100% 100%;
        box-sizing: border-box;
        padding: 50px 60px;
      }
    }
    .diamond{
      position: relative;
      display: inline-block;
      // width: 840px;
      width: 43%;
      height: 458px;
      margin-top: 120px;
      margin-left: 20px;
      .diamond-img{
        position: absolute;
        display: block;
        // width: 980px;
        width: 146%;
        left: -152px;
        top: -150px;
        object-fit: cover;
      }
    }
  }
}
@media screen and (max-width: 1500px) {
  .login{
    .login-main{
      .diamond{
        .diamond-img{
          top: -70px;
          left: -100px;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .login{
    .login-main{
      .diamond{
        .diamond-img{
          // top: -60px;
          top: -15px;
          left: -60px;
        }
      }
    }
  }
}
@media screen and (max-width: 860px) {
  .login{
    .login-main{
      padding-left: 65px;
      padding-right: 55px;
      .diamond{
        // width: 800px;
        .diamond-img{
          top: 70px;
          left: -30px;
        }
      }
    }
  }
}
@media screen and (max-height: 800px) {
    .login{
    .login-main{
      padding-top: 78px;
      padding-bottom: 78px;
    }
  }
}

</style>